(function () {
  function init() {
    $(".officehome_toolbar").each(function () {
      var win = $(window);
      var $this = $(this);

      //탑버튼
      /* BTOCSITE-30650 [모니터링] 야간무인매장 > 야간무인매장 구경가기 > 지점 선택 > 매장 홈페이지에서 스크롤 하지 않았음에도 탑버튼 노출되는 현상 */
      function topBtn(){
        var wrap = $this.prevAll(".cont-wrap");
        var scrollTop = win.scrollTop();
        if (window.pageYOffset > 100 && scrollTop + win.height() < wrap.outerHeight(true) ) {
          $this.filter(".pc").find(".gotop").addClass("show").removeClass("blind");
          $this.filter('.pc').css("bottom", "114px");
        } else if(window.pageYOffset > 100 && scrollTop + win.height() >= wrap.outerHeight(true)) {
          $this.filter(".pc").find(".gotop").addClass("blind").removeClass("show");
          $this.filter(".pc").css("bottom", "42px");
        } else if(window.pageYOffset < 100) {
          $this.filter(".pc").find(".gotop").removeClass("show");
          $this.filter(".pc").css("bottom", "42px");
        }
      }

      topBtn();

      $(window).scroll(function(){
        topBtn();
      });
      /* //BTOCSITE-30650 [모니터링] 야간무인매장 > 야간무인매장 구경가기 > 지점 선택 > 매장 홈페이지에서 스크롤 하지 않았음에도 탑버튼 노출되는 현상 */

      $this
        .filter(".pc")
        .find(".gotop")
        .on("click", function (e) {
          e.preventDefault();
          if (win.scrollTop() !== 0) {
            $("body, html").stop().animate({ scrollTop: 0 }, 200);
          }
        });

      //지도영역 이동
      // $this.find(".locate a").each(function () {
      //   var $this = $(this);
      //   $this.on("click", function (e) {
      //     if ($(document).find(".officehome_map").length > 0) {
      //       e.preventDefault();
      //     }
      //     var mapArea = $(document).find(".officehome_map");
      //     if (mapArea.length > 0) {
      //       var headSize = 0;
      //       $(".officehome_head, .officehome_menu").each(function () {
      //         var $this = $(this);
      //         headSize += $this.outerHeight(true);
      //       });
      //       $(window).scrollTop(mapArea.offset().top - headSize);
      //     }
      //   });
      // });

      //툴바 show/hide
      $(window).on("scroll.toolbar", function () {
        var wrap = $this.prevAll(".cont-wrap");
        var scrollTop = win.scrollTop();
        if ($this.hasClass("pc")) {
          // pc 좌측 툴바 show/hide
          if (
            scrollTop + win.height() >= wrap.outerHeight(true) &&
            !$this.hasClass("blind")
          ) {
            $this.addClass("blind");
          } else if (
            scrollTop + win.height() < wrap.outerHeight(true) &&
            $this.hasClass("blind")
          ) {
            $this.removeClass("blind");
          }
        }
      });

      //툴바 제어
      $(window)
        .off("resize.tool")
        .on("resize.tool", function () {
          $(".tooltip-wrap").each(function () {
            var $this = $(this);
            var box = $this.find(".tooltip-box");
            if ($this.closest(".addon_area").length > 0) {
              box.css({
                top: "40px",
                left:
                  $(window).width() / 2 -
                  $this.offset().left -
                  box.outerWidth() / 2,
              });
            } else {
              if (vcui.detect.isIOS || vcui.detect.isAndroid) {
              } else {
                box.css({ top: "-132px", right: "80px" });
              }
            }
          });
        });
    });

    // start 20220530 sns data-url 삭제 (값이 없어야 현재 링크로 들어감)
    // start 20220629 위치이동
    $(".sns-list>li>a").each(function () {
      var $this = $(this);
      $this.attr(
        "data-url",
        vcui.uri.updateQueryParam(
          location.href,
          "status",
          lgkorUI.getParameterByName("status")
        )
      );
    });
    // end 20220629 위치이동
    // end 20220530 sns data-url 삭제 (값이 없어야 현재 링크로 들어감)

    // start 20220629 삭제
    $(document).on("click", ".officehome_head > .btn-close", function () {
      // 닫기 버튼
      window.close();
    });
    // end 20220629 삭제

    $(document).on("click", ".btn-back", function () {
      var start = lgkorUI.getParameterByName("status");
      // 뒤로가기 버튼
      if (document.referrer.indexOf("storemode") > -1 || $(document).find('.mainpage').length > 0) {
        if (start === "lg" || isApp()) {
          // BTOCSITE-37855 검색 > 센터/매장 유닛 > 베스트샵 상세보기 뒤로가기 버튼 클릭 시, 매장찾기로 이동 수정 - 검색에서 진입 시, 이전 페이지로 이동하도록 수정
          if (document.referrer.indexOf("/search/result") > -1 || document.referrer.indexOf("/my-page/favorites-shop") > -1) { // BTOCSITE-67091
            history.back();
            return;
          }
          // BTOCSITE-23853 매장홈페이지 뒤로가기 버튼 > 무인매장안내페이지 추가
          var detail = lgkorUI.getParameterByName("detail");
          if(detail === 'ut'){
            location.href = "/bestshop/untact-store";
          }else{
            location.href = "/bestshop/store-finder";
          }
        } else {
          if (window.location.origin === "https://wwwdev50.lge.co.kr") {
            //dev
            location.href = "https://bestshopdev.lge.co.kr/shop/findBestshop";
          } else if (window.location.origin === "https://wwwstg.lge.co.kr") {
            //stg
            location.href = "https://bestshopstg.lge.co.kr/shop/findBestshop";
          } else {
            //운영
            location.href = "https://bestshop.lge.co.kr/shop/findBestshop";
          }
        }
      } else {
      history.back();
      }
    });

    // 홈버튼 링크 이동
    // start 20220531 LGECOMVIO-41 링크 이동 수정
    // $(document).on("click", ".toolbar_item.home a", function () {
    //   var $this = $(this);
    //   var start = lgkorUI.getParameterByName("status");
    //   var share = lgkorUI.getParameterByName("share");

    //   if (isApp() || vcui.detect.isAndroid || vcui.detect.isIOS) {
    //     if (start === "lg") {
    //       location.href = "/";
    //     } else {
    //       if (window.location.origin === "https://wwwdev50.lge.co.kr") {
    //         //dev
    //         location.href = "https://bestshopdev.lge.co.kr";
    //       } else if (window.location.origin === "https://wwwstg.lge.co.kr") {
    //         //stg
    //         location.href = "https://bestshopstg.lge.co.kr";
    //       } else {
    //         //운영
    //         location.href = "https://bestshop.lge.co.kr";
    //       }
    //     }
    //   }
    // });
    // end 20220531 LGECOMVIO-41 링크 이동 수정

    //링크 이동 분기 처리
    // start 20220531 LGECOMVIO-41 링크 이동 수정
    $(document).on("click", "a", function (e) {
      var $this = $(e.currentTarget);
      var url = $this.data("url");
      if (url !== undefined && url !== "#") {
        e.preventDefault();
        var start = lgkorUI.getParameterByName("status");
        var share = lgkorUI.getParameterByName("share");
        if (start === "lg") {
          //lge.com
          if (
            $(document).find(".officehome_infohead.coupon").length > 0 ||
            $this.closest("#event_info").length > 0 ||
            $this.closest(".officehome_mainlist.event").length > 0 ||
            $this.closest(".officehome_mainlist.coupon").length > 0 ||
            //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220913 start
            $this.closest(".recom_list").length > 0
            //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220913 end
          ) {
            // 쿠폰 & 이벤트
            if (isApp()) {
              if (vcui.detect.isIOS) {
                var jsonString = JSON.stringify({
                  command: "openLinkOut",
                  url: url,
                });
                webkit.messageHandlers.callbackHandler.postMessage(jsonString);
              } else if (vcui.detect.isAndroid) {
                android.openLinkOut(url);
              }
            } else {
              if (vcui.detect.isIOS || vcui.detect.isAndroid) {
                // 모바일 웹
                window.open(url);
              } else {
                if (share === "Y") {
                  location.href = url;
                } else {
                  // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                  if (window.opener === null || window.opener === undefined) {
                    location.href = url;
                  } else {
                    window.open(url);
                  }
                  // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                }
              }
            }
          }

          if (
            $this.closest(".officehome_boxlist.product").length > 0 ||
            $this.closest(".officehome_mainlist.product").length > 0 ||
            $this.closest(".officehome_mainlist.product.shopdp").length > 0 ||
            $this.closest(".officehome_mainlist.product.my_interest").length >
              0 ||
            //베스트샵 지점별 홈페이지 2차 영업 안내 인기제품 20220905 start
            $this.closest(".popular_goods").length > 0 ||
            $this.closest(".popular").length > 0
            //베스트샵 지점별 홈페이지 2차 영업 안내 인기제품 20220905 end
          ) {
            // 제품
            if (isApp() || vcui.detect.isAndroid || vcui.detect.isIOS) {
              //모바일
              location.href = url;
            } else {
              // pc
              if (share === "Y") {
                location.href = url;
              } else {
                // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                if (window.opener === null || window.opener === undefined) {
                  location.href = url;
                } else {
                  window.open(url);
                }
                // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
              }
            }
          }

          if ($this.closest(".officehome_booking").length > 0) {
            //상담 예약 바로가기 링크
            if (
              $this.hasClass("online") ||
              $this.hasClass("offline") ||
              $this.data("login") === "Y"
            ) {
              // 영상 상담, 매장 상담, 상담예약조회(로그인)
              if (isApp() || vcui.detect.isAndroid || vcui.detect.isIOS) {
                location.href = url;
              } else {
                if (share === "Y") {
                  location.href = url;
                } else {
                  // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                  if (window.opener === null || window.opener === undefined) {
                    location.href = url;
                  } else {
                    window.open(url);
                  }
                  // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                }
              }
            } else {
              if (isApp()) {
                if (vcui.detect.isIOS) {
                  var jsonString = JSON.stringify({
                    command: "openLinkOut",
                    url: url,
                  });
                  webkit.messageHandlers.callbackHandler.postMessage(
                    jsonString
                  );
                } else if (vcui.detect.isAndroid) {
                  android.openLinkOut(url);
                }
              } else {
                if (vcui.detect.isIOS || vcui.detect.isAndroid) {
                  window.open(url);
                } else {
                  if (share === "Y") {
                    location.href = url;
                  } else {
                    // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                    if (window.opener === null || window.opener === undefined) {
                      location.href = url;
                    } else {
                      window.open(url);
                    }
                    // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                  }
                }
              }
            }
          }

          if ($this.closest(".toolbar_item.reserve").length > 0) {
            //기타 list) 매장상담신청
            if (isApp() || vcui.detect.isAndroid || vcui.detect.isIOS) {
              location.href = url;
            } else {
              if (share === "Y") {
                location.href = url;
              } else {
                // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                if (window.opener === null || window.opener === undefined) {
                  location.href = url;
                } else {
                  window.open(url);
                }
                // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
              }
            }
          }
        } else {
          //bs
          if (
            $this.closest("#event_info").length > 0 ||
            $this.closest(".officehome_mainlist.event").length > 0
          ) {
            // 이벤트
            if (vcui.detect.isIOS || vcui.detect.isAndroid) {
              window.open(url);
            } else {
              if (share === "Y") {
                location.href = url;
              } else {
                // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                if (window.opener === null || window.opener === undefined) {
                  location.href = url;
                } else {
                  window.open(url);
                }
                // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
              }
            }
          }
          if (
            $(document).find(".officehome_infohead.coupon").length > 0 ||
            $this.closest(".officehome_mainlist.coupon").length > 0 ||
            //베스트샵 지점별 홈페이지 2차 영업 안내 인기제품 20220905 start
            $this.closest(".popular_goods").length > 0 ||
            $this.closest(".popular").length > 0
            //베스트샵 지점별 홈페이지 2차 영업 안내 인기제품 20220905 end
          ) {
            // 쿠폰
            if (vcui.detect.isIOS || vcui.detect.isAndroid) {
              location.href = url;
            } else {
              if (share === "Y") {
                location.href = url;
              } else {
                // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                if (window.opener === null || window.opener === undefined) {
                  location.href = url;
                } else {
                  window.open(url);
                }
                // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
              }
            }
          }
          if (
            $this.closest(".officehome_boxlist.product").length > 0 ||
            $this.closest(".officehome_mainlist.product").length > 0 ||
            $this.closest(".officehome_mainlist.product.shopdp").length > 0 ||
            $this.closest(".officehome_mainlist.product.my_interest").length >
              0 ||
            //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220913 start
            $this.closest(".recom_list").length > 0
            //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220913 end
          ) {
            // 제품
            if (vcui.detect.isIOS || vcui.detect.isAndroid) {
              window.open(url);
            } else {
              if (share === "Y") {
                location.href = url;
              } else {
                // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                if (window.opener === null || window.opener === undefined) {
                  location.href = url;
                } else {
                  window.open(url);
                }
                // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
              }
            }
          }

          if ($this.closest(".officehome_booking").length > 0) {
            //상담 예약 바로가기 링크
            if (
              $this.hasClass("online") ||
              $this.hasClass("offline") ||
              $this.data("login") === "Y"
            ) {
              // 영상 상담, 매장 상담, 상담예약조회(로그인)
              if (vcui.detect.isIOS || vcui.detect.isAndroid) {
                window.open(url);
              } else {
                if (share === "Y") {
                  location.href = url;
                } else {
                  // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                  if (window.opener === null || window.opener === undefined) {
                    location.href = url;
                  } else {
                    window.open(url);
                  }
                  // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                }
              }
            } else {
              if (vcui.detect.isIOS || vcui.detect.isAndroid) {
                location.href = url;
              } else {
                if (share === "Y") {
                  location.href = url;
                } else {
                  // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                  if (window.opener === null || window.opener === undefined) {
                    location.href = url;
                  } else {
                    window.open(url);
                  }
                  // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                }
              }
            }
          }

          if ($this.closest(".toolbar_item.reserve").length > 0) {
            //기타 list) 매장상담신청
            if (isApp()) {
              if (vcui.detect.isIOS) {
                var jsonString = JSON.stringify({
                  command: "openLinkOut",
                  url: url,
                });
                webkit.messageHandlers.callbackHandler.postMessage(jsonString);
              } else if (vcui.detect.isAndroid) {
                android.openLinkOut(url);
              }
            } else {
              if (vcui.detect.isIOS || vcui.detect.isAndroid) {
                window.open(url);
              } else {
                if (share === "Y") {
                  location.href = url;
                } else {
                  // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                  if (window.opener === null || window.opener === undefined) {
                    location.href = url;
                  } else {
                    window.open(url);
                  }
                  // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                }
              }
            }
          }
        }

        if ($this.hasClass("ch_kakao")) {
          //카카오 링크
          if (isApp()) {
            if (vcui.detect.isIOS) {
              var jsonString = JSON.stringify({
                command: "openLinkOut",
                url: url,
              });
              webkit.messageHandlers.callbackHandler.postMessage(jsonString);
            } else if (vcui.detect.isAndroid) {
              android.openLinkOut(url);
            }
          } else if (vcui.detect.isIOS || vcui.detect.isAndroid) {
            window.open(url);
          }
        }
      }
    });
    // end 20220531 LGECOMVIO-41 링크 이동 수정

    //베스트샵 지점별 홈페이지 2차 영업 안내 위시리스트 등록 20220905 start
    var doc = $(document);
    doc.on("change", ".prod_box .btn_popular_like", function (e) {
      e.preventDefault();
      var $this = $(e.currentTarget);
      var aTag = $this.closest(".prod_box").children("a");
      var param = aTag.data("gateUrl").split("?")[1];
      var modelId = param.split("&")[1].split("=")[1];
      var storeId = param.split("&")[0].split("=")[1];
      var myWishListUrl =
        doc.find(".contents").data("myWishListUrl") ||
        "/mkt/api/bestshop/storemode/wishlist/modifyWishlist";
      loginChk(function () {
        if ($this.prop("checked")) {
          lgkorUI.requestAjaxDataPost(
            myWishListUrl,
            {
              type: "add",
              modelId: modelId,
              wishType: "10",
              storeId: storeId,
            },
            function (result) {
              $(window).trigger(
                "toastshow",
                "선택하신 제품이 위시리스트에 추가되었습니다."
              );
              $this.prop("checked", true); // ture 버그 수정
            }
          );
        } else {
          lgkorUI.requestAjaxDataPost(
            myWishListUrl,
            {
              type: "remove",
              modelId: modelId,
              wishType: "10",
              storeId: storeId,
            },
            function (result) {
              $(window).trigger(
                "toastshow",
                "선택하신 제품이 위시리스트에서 삭제되었습니다."
              );
              $this.prop("checked", false);
            }
          );
        }
      });
    });
    function loginChk(callBack, cancelBack, backLink) {
      var doc = $(document);
      var loginUrl = "/sso/member/login?state=";
      var moveUrl = backLink || location.pathname + location.search;
      
        // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선
        var isLogin =  digitalData.userInfo.isLogin;
        if (!isLogin) {
          doc.find(".btn_popular_like").each(function () {
            var $this = $(this);
            $this.prop("checked", false);
          });
          lgkorUI.confirm("로그인 후 이용가능 합니다.<br>로그인하시겠어요? ", {
            title: "",
            cancelBtnName: "아니오",
            okBtnName: "네",
            cancel: function () {
              if (cancelBack !== undefined && cancelBack !== null) {
                cancelBack();
              }
            },
            ok: function () {
              if (isApp() || vcui.detect.isAndroid || vcui.detect.isIOS) {
                      
                location.href = vcui.uri.updateQueryParam(
                  loginUrl,
                  "state",
                  encodeURIComponent(moveUrl)
                );

              } else {
                if (lgkorUI.getParameterByName("share") === "Y") {
                  
                  location.href = vcui.uri.updateQueryParam(
                    loginUrl,
                    "state",
                    encodeURIComponent(moveUrl)
                  );

                } else {
                  // start 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                  if (
                    window.opener === null ||
                    window.opener === undefined
                  ) {
                    location.href = vcui.uri.updateQueryParam(
                      loginUrl,
                      "state",
                      encodeURIComponent(location.pathname)
                    );
                  } else {
                    window.opener.location.href =
                      vcui.uri.updateQueryParam(
                        loginUrl,
                        "state",
                        encodeURIComponent((lgkorUI.getParameterByName("detail") === 'ut') ? '/bestshop/untact-store' : '/support/store-finder')
                      );
                    window.close();
                  }
                  // end 20220602 LGECOMVIO-41 pc 윈도우 팝업이 아닐때 케이스 추가
                }
              }
            },
          });
        } else {
          if (callBack !== undefined && callBack !== null) {
            callBack();
          }
        }
     
    }
    //베스트샵 지점별 홈페이지 2차 영업 안내 위시리스트 등록 20220905 end
  }
  $(document).ready(function () {
    init();

    // start 20220531 LGECOMVIO-41 status 따라 자창 링크이동 파라미터 정의
    // start 20220602 LGECOMVIO-41 moveMap -> mapMove 수정 및 파람 수정
    $(
      ".officehome_menu .tabs > li > a, .list_more > a, .toolbar_item.locate > a"
    ).each(function () {
      var $this = $(this);
      var href = $this.attr("href");
      var customUrl = vcui.uri.updateQueryParam(
        href,
        "status",
        lgkorUI.getParameterByName("status")
      );

      // BTOCSITE-23853 매장홈페이지 뒤로가기 버튼 > 무인매장안내페이지 추가
      var detail = lgkorUI.getParameterByName("detail");
      if(detail === 'ut'){
        customUrl = vcui.uri.updateQueryParam(customUrl, "detail", detail);
      }

      // 전시 더보기
      if ($this.closest(".shopdp").length > 0) {
        customUrl = vcui.uri.updateQueryParam(customUrl, "tabs", "1");
      }

      // 위치찾기
      if ($this.closest(".toolbar_item.locate").length > 0) {
        customUrl = vcui.uri.updateQueryParam(customUrl, "mapMove", "1");
      }

      $this.attr("href", customUrl);
    });
    // end 20220602 LGECOMVIO-41 moveMap -> mapMove 수정 및 파람 수정
    // end 20220531 LGECOMVIO-41 status 따라 자창 링크이동 파라미터 정의
  });
  $(window).on("load", function () {
    $(window).trigger("resize");
  });
})();
